import React, {useState, useRef, useEffect} from 'react';
import { useCTAL } from './CTAL_Hooks.js';
import { Auth } from 'aws-amplify';

const DEBUG = 0;

export default function User() 
{
    const { user_id, setUserID, app_user, setAppUser, setTeamID, setActionItemListDisplay, 
            user_display_refresh, setUserDisplayRefresh,
            setUserShortList, setUserLongList, setUserPublicTeamList, setUserTeamInvitationsList, setUserJoinRequestsList } = useCTAL();
            
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const fetchRef = useRef("");
    const initRef = useRef("");
    const setupRef = useRef("");

    var type, user_name, search_body;

    useEffect(() =>
    {
        if (setupRef.id == "DONE") return;

        setupRef.id = "DONE"; //Make sure this only runs once

        Auth.currentAuthenticatedUser()
            .then(init_cognito_user)
            .catch(err => console.log(err))

        console.log(`User: Initializing Cognito User`);

    }, []); //Call once

    const init_cognito_user = (auth_user) => { 
        
        console.log(`User**: ${auth_user.username}, ${auth_user.attributes.given_name} ${auth_user.attributes.family_name}, ${auth_user.attributes.email}`);

        //For some reason, storing the auth_user (all or part) did not work ... some kind of promise issue

        type = "get_user_by_name";
        user_name = auth_user.username;
        search_body = JSON.stringify({type, user_name});

        console.log(`User** - fetching Cognito User by Username from ctal-get for: ${search_body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-get`, { method: "POST", body: search_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: search_body })
            .then(response => response.json())
            .then(cognito_user => set_cognito_user(cognito_user, auth_user.username, auth_user.attributes.given_name, auth_user.attributes.family_name, auth_user.attributes.email))
            .catch(error => set_cognito_user_not_found(error, auth_user.username, auth_user.attributes.given_name, auth_user.attributes.family_name, auth_user.attributes.email));
    }
    
    const set_cognito_user_not_found = (error, username, first_name, last_name, email) => {
        console.log(`User**: (ERROR) Cognito User not found in CTAL DB`);
        create_new_user(username, first_name, last_name, email);
    } 

    const set_cognito_user = (cognito_user, username, first_name, last_name, email) => { 
        if (cognito_user) {
            console.log(`User**: Cognito User FOUND in CTAL DB, user_id: ${cognito_user.UserID}`);
            setUserID(cognito_user.UserID);
            return;
        }

        console.log(`User**: Cognito User not found in CTAL DB`);
        create_new_user(username, first_name, last_name, email);
    }

    const create_new_user = (username, first_name, last_name, email) => { 
        console.log(`User**:  create_new_user ${username}, ${first_name} ${last_name}, ${email}`);

        if ((!username) || (username.length == 0))
            return;

        var default_prefix = first_name[0] + last_name[0];
        default_prefix = default_prefix.toUpperCase();

        type = "create_user_ui";
        var UserName = username; 
        var UserDesc = "New User"; 
        var UserPhoneCountry = ""; 
        var UserPhone = ""; 
        var UserEmail = email; 
        var UserFirstName = first_name; 
        var UserMiddleName = ""; 
        var UserLastName = last_name; 
        var UserContactPref = "Email"; 
        var ActionIDPrefix = default_prefix;             
        search_body = JSON.stringify({type, UserName, UserDesc, UserPhoneCountry, UserPhone, UserEmail, UserFirstName, UserMiddleName, UserLastName, UserContactPref, ActionIDPrefix});
        
        console.log(`User - Creating User from ctal-set: ${search_body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-set`, { method: "POST", body: search_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: search_body })
            .then(response => response.json())
            .then(new_user => set_new_user(new_user, username))
            .catch(create_new_user_error); 
    }
    
    const set_new_user = (new_user, username) => { 
        if (new_user) {
            //console.log(`User**: New User CREATED in CTAL DB, user_id: ${new_user.UserID}`);
            console.log(`User**: New User CREATED in CTAL DB`);

            type = "get_user_by_name";
            user_name = username;
            search_body = JSON.stringify({type, user_name});
    
            console.log(`User** - fetching Created User by Username from ctal-get for: ${search_body}`);
            //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-get`, { method: "POST", body: search_body })
            fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: search_body })
                .then(response => response.json())
                .then(found_user => setUserID(found_user.UserID))
                .catch(set_cognito_user_not_found);

            return;
        }

        console.log(`User**: New User NOT CREATED in CTAL DB`);
        //TODO - Handle User Creation Problem
    }

    const create_new_user_error = (create_user_error) => { 
        console.log(`User**: Create new User Error: ${create_user_error}`);

        //TODO - Handle User Creation Problem

    }

    if (DEBUG) console.log(`User** - user_id from Context: ${user_id}`);

    const init_main_display = () => { 
      
        if (initRef.id == app_user.UserID) return;
            initRef.id = app_user.UserID;

        setTeamID(app_user.PrivateTeamID);
        setActionItemListDisplay("user-short-list-display"); //
        if (DEBUG) console.log(`User** - initializing main display ShortList`);
    }

        
    const populate_all_user_item_items = (items) => { 
        //if (DEBUG) console.log(`User** - num app_user (bulk) items: ${items.length}`);

        var user_items = items.filter( item => { return (item.Type === "User"); } );
        var user_short_lists = items.filter( item => { return ((item.Type === "List") && (item.ListType === "User-List")); } );
        var user_long_lists = items.filter( item => { return ((item.Type === "List") && (item.ListType === "Team-List")); } );

        setAppUser(user_items[0]); 
        setUserShortList(user_short_lists[0]);
        setUserLongList(user_long_lists[0]);
        setUserPublicTeamList(items.filter( item => { return (item.Type === "Team"); } ));
        setUserTeamInvitationsList(items.filter( item => { return ((item.Type === "Member") && (item.TeamRole === "Team-Invitation")); } ));
        setUserJoinRequestsList(items.filter( item => { return ((item.Type === "Member") && (item.TeamRole === "Member-Join-Request")); } ));
    }

    useEffect(() =>
    {
        if (!user_id) return;
        
        if ((fetchRef.id == user_id) && (!user_display_refresh)) return;
        fetchRef.id = user_id;
        
        //Setting user_display_refresh to false in UserColumn
  
        type = "get_user_all";
        search_body = JSON.stringify({type, user_id});
    
        console.log(`User - fetching User (bulk) from ctal-get for: ${user_id}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-get`, { method: "POST", body: search_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: search_body })
            .then(response => response.json())
            .then(populate_all_user_item_items)
            .then(() => setLoading(false))
            .catch(setError);
    }, [user_id, user_display_refresh]);

    //Initialize Main Display to User's Short-List
    useEffect(() => { if (app_user) init_main_display(); }, [app_user]);

    if (loading) return <h1>Loading User...</h1>;
    if (error) return <pre>{JSON.stringify(error, null, 2)}</pre>
    if (!app_user) return null;
      
    if (DEBUG) { console.log(`User - UserFullName: ${app_user.UserFullName}`); return; }

    return ( <> </> );
}